import React from 'react';

const StatusBadge = ({ status, onChange }) => {
  const getStatusClass = () => {
    switch (status.toLowerCase()) {
      case 'published':
      case 'publish':
        return 'sales-status-published';
      case 'draft':
        return 'sales-status-draft';
      case 'cancelled':
      case 'cancel':
        return 'sales-status-cancelled';
      default:
        return 'sales-status-default';
    }
  };

  return (
    <span className={`sales-status-badge ${getStatusClass()}`}>
      {status}
    </span>
  );
};

export default StatusBadge;